import { ChartType } from '../entities/chart-type';

import { chartTypeLabel } from './chart/utils';

export type ChartSkeletonProps = {
  chartType: ChartType;
};

export function ChartSkeleton({ chartType }: ChartSkeletonProps) {
  return (
    <div className="chartContainer">
      <div className="flex h-64 flex-col">
        {/* Chart title skeleton */}
        <div className="flex items-center justify-between px-4 py-3">
          <div className="h-5 w-32 animate-pulse rounded bg-gray-100"></div>
          <div className="h-4 w-24 animate-pulse rounded bg-gray-50"></div>
        </div>
        {/* Chart area skeleton */}
        <div className="flex-1 p-4">
          <div className="size-full animate-pulse rounded bg-gray-50">
            {/* Subtle chart-like lines */}
            <div className="flex h-full items-end justify-around px-8 pb-8">
              {[...Array(8)].map((_, i) => (
                <div
                  key={i}
                  className="animate-pulse bg-gray-100"
                  style={{
                    width: '2px',
                    height: `${Math.random() * 60 + 20}%`,
                    animationDelay: `${i * 0.1}s`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
        {/* Loading text */}
        <div className="px-4 pb-3">
          <div className="flex items-center text-sm text-gray-500">
            <div className="mr-2 size-3 animate-spin rounded-full border border-gray-300 border-t-[var(--primary-color)]"></div>
            Loading {chartTypeLabel[chartType]}...
          </div>
        </div>
      </div>
    </div>
  );
}
